var _ellipse, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _g3, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconGetStartedTermPolicy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 113,
    viewBox: "0 0 161 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.6845,
    cy: 55.8175,
    rx: 53.5321,
    ry: 53.9141,
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6043_124548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7858 42.8145H149.063C150.107 42.8145 151.108 43.2321 151.846 43.9756C152.585 44.719 152.999 45.7273 152.999 46.7787V66.6002C152.999 67.6516 152.585 68.6599 151.846 69.4033C151.108 70.1468 150.107 70.5645 149.063 70.5645H42.7858C41.7419 70.5645 40.7407 70.1468 40.0025 69.4033C39.2643 68.6599 38.8496 67.6516 38.8496 66.6002V46.7787C38.8496 45.7273 39.2643 44.719 40.0025 43.9756C40.7407 43.2321 41.7419 42.8145 42.7858 42.8145V42.8145Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.041 49.1572H80.5727C79.2683 49.1572 78.2109 50.2221 78.2109 51.5358C78.2109 52.8494 79.2683 53.9144 80.5727 53.9144H101.041C102.345 53.9144 103.403 52.8494 103.403 51.5358C103.403 50.2221 102.345 49.1572 101.041 49.1572Z",
    fill: "#E0E0E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.211 59.4648H80.5727C79.2683 59.4648 78.2109 60.5298 78.2109 61.8434C78.2109 63.1571 79.2683 64.222 80.5727 64.222H115.211C116.516 64.222 117.573 63.1571 117.573 61.8434C117.573 60.5298 116.516 59.4648 115.211 59.4648Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8616 64.2215C66.992 64.2215 70.3404 60.8493 70.3404 56.6894C70.3404 52.5295 66.992 49.1572 62.8616 49.1572C58.7312 49.1572 55.3828 52.5295 55.3828 56.6894C55.3828 60.8493 58.7312 64.2215 62.8616 64.2215Z",
    fill: "#FDBE44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4188 58.527H58.5332L60.1457 53.9141H61.17L62.7847 58.527H61.8991L60.6757 54.8601H60.64L59.4188 58.527ZM59.4479 56.7183H61.8633V57.3896H59.4479V56.7183Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.388 58.527V53.9141H65.1414C65.4724 53.9141 65.7475 53.9666 65.9667 54.0717C66.1873 54.1753 66.3521 54.3172 66.4609 54.4974C66.5713 54.6776 66.6264 54.8819 66.6264 55.1101C66.6264 55.2978 66.5906 55.4585 66.5191 55.5921C66.4475 55.7243 66.3513 55.8316 66.2306 55.9142C66.1098 55.9968 65.9749 56.0561 65.8258 56.0922V56.1372C65.9883 56.1462 66.1441 56.1965 66.2932 56.2881C66.4438 56.3782 66.5668 56.5059 66.6622 56.671C66.7576 56.8362 66.8053 57.0359 66.8053 57.2702C66.8053 57.5089 66.7479 57.7237 66.6331 57.9144C66.5183 58.1036 66.3454 58.253 66.1143 58.3626C65.8832 58.4722 65.5924 58.527 65.2421 58.527H63.388ZM64.2177 57.8288H65.1101C65.4113 57.8288 65.6282 57.771 65.7609 57.6553C65.8951 57.5382 65.9622 57.3881 65.9622 57.2049C65.9622 57.0682 65.9286 56.9451 65.8616 56.8355C65.7945 56.7243 65.699 56.6372 65.5753 56.5742C65.4515 56.5096 65.3039 56.4773 65.1325 56.4773H64.2177V57.8288ZM64.2177 55.8759H65.0385C65.1817 55.8759 65.3106 55.8497 65.4254 55.7971C65.5402 55.743 65.6305 55.6672 65.6961 55.5696C65.7631 55.4705 65.7967 55.3534 65.7967 55.2182C65.7967 55.0395 65.7341 54.8924 65.6088 54.7767C65.4851 54.6611 65.3009 54.6033 65.0564 54.6033H64.2177V55.8759Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6043_124548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9362 76.9072H115.214C116.257 76.9072 117.259 77.3249 117.997 78.0683C118.735 78.8118 119.15 79.8201 119.15 80.8715V100.693C119.15 101.744 118.735 102.753 117.997 103.496C117.259 104.24 116.257 104.657 115.214 104.657H8.9362C7.89225 104.657 6.89107 104.24 6.15289 103.496C5.41471 102.753 5 101.744 5 100.693V80.8715C5 79.8201 5.41471 78.8118 6.15289 78.0683C6.89107 77.3249 7.89225 76.9072 8.9362 76.9072V76.9072Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1913 83.251H46.723C45.4187 83.251 44.3613 84.3159 44.3613 85.6295C44.3613 86.9432 45.4187 88.0081 46.723 88.0081H67.1913C68.4956 88.0081 69.553 86.9432 69.553 85.6295C69.553 84.3159 68.4956 83.251 67.1913 83.251Z",
    fill: "#E0E0E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3616 93.5586H46.723C45.4187 93.5586 44.3613 94.6235 44.3613 95.9372C44.3613 97.2508 45.4187 98.3157 46.723 98.3157H81.3616C82.6659 98.3157 83.7233 97.2508 83.7233 95.9372C83.7233 94.6235 82.6659 93.5586 81.3616 93.5586Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7776 98.3162C22.908 98.3162 26.2564 94.944 26.2564 90.7841C26.2564 86.6242 22.908 83.252 18.7776 83.252C14.6472 83.252 11.2988 86.6242 11.2988 90.7841C11.2988 94.944 14.6472 98.3162 18.7776 98.3162Z",
    fill: "#FDBE44"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7328 89.4982C17.7119 89.3015 17.624 89.1483 17.4689 89.0387C17.3153 88.9291 17.1155 88.8743 16.8695 88.8743C16.6966 88.8743 16.5482 88.9005 16.4245 88.9531C16.3007 89.0056 16.2061 89.077 16.1404 89.1671C16.0748 89.2572 16.0413 89.36 16.0398 89.4757C16.0398 89.5718 16.0614 89.6551 16.1047 89.7257C16.1494 89.7962 16.2098 89.8563 16.2858 89.9059C16.3619 89.9539 16.4461 89.9945 16.5385 90.0275C16.631 90.0605 16.7242 90.0883 16.8181 90.1108L17.2475 90.219C17.4205 90.2595 17.5867 90.3143 17.7462 90.3834C17.9073 90.4525 18.0511 90.5395 18.1779 90.6447C18.3061 90.7498 18.4075 90.8767 18.482 91.0253C18.5566 91.174 18.5939 91.3482 18.5939 91.5479C18.5939 91.8182 18.5253 92.0562 18.3881 92.2619C18.2509 92.4661 18.0526 92.626 17.7932 92.7417C17.5353 92.8558 17.2229 92.9129 16.8561 92.9129C16.4998 92.9129 16.1904 92.8573 15.928 92.7462C15.6671 92.6351 15.4628 92.4729 15.3152 92.2597C15.1691 92.0464 15.0901 91.7866 15.0781 91.4803H15.8944C15.9064 91.641 15.9556 91.7746 16.042 91.8812C16.1285 91.9879 16.2411 92.0674 16.3798 92.12C16.5199 92.1726 16.6765 92.1988 16.8494 92.1988C17.0298 92.1988 17.1879 92.1718 17.3235 92.1177C17.4607 92.0622 17.5681 91.9856 17.6456 91.888C17.7231 91.7889 17.7626 91.6733 17.7641 91.5411C17.7626 91.421 17.7276 91.3219 17.659 91.2438C17.5904 91.1642 17.4943 91.0982 17.3705 91.0456C17.2482 90.9915 17.1051 90.9435 16.9411 90.9014L16.42 90.7663C16.0428 90.6687 15.7446 90.5208 15.5254 90.3226C15.3077 90.1229 15.1989 89.8578 15.1989 89.5275C15.1989 89.2557 15.272 89.0177 15.4181 88.8134C15.5657 88.6092 15.7662 88.4508 16.0197 88.3382C16.2731 88.2241 16.5602 88.167 16.8807 88.167C17.2058 88.167 17.4905 88.2241 17.7351 88.3382C17.9811 88.4508 18.1741 88.6077 18.3143 88.8089C18.4544 89.0086 18.5268 89.2384 18.5312 89.4982H17.7328Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8228 89.4982C21.8019 89.3015 21.7139 89.1483 21.5589 89.0387C21.4053 88.9291 21.2055 88.8743 20.9595 88.8743C20.7865 88.8743 20.6382 88.9005 20.5144 88.9531C20.3907 89.0056 20.296 89.077 20.2304 89.1671C20.1648 89.2572 20.1312 89.36 20.1298 89.4757C20.1298 89.5718 20.1514 89.6551 20.1946 89.7257C20.2393 89.7962 20.2997 89.8563 20.3758 89.9059C20.4518 89.9539 20.536 89.9945 20.6285 90.0275C20.7209 90.0605 20.8141 90.0883 20.908 90.1108L21.3374 90.219C21.5104 90.2595 21.6766 90.3143 21.8362 90.3834C21.9972 90.4525 22.1411 90.5395 22.2678 90.6447C22.396 90.7498 22.4974 90.8767 22.572 91.0253C22.6465 91.174 22.6838 91.3482 22.6838 91.5479C22.6838 91.8182 22.6152 92.0562 22.478 92.2619C22.3409 92.4661 22.1426 92.626 21.8831 92.7417C21.6252 92.8558 21.3128 92.9129 20.9461 92.9129C20.5897 92.9129 20.2803 92.8573 20.0179 92.7462C19.757 92.6351 19.5527 92.4729 19.4051 92.2597C19.259 92.0464 19.18 91.7866 19.1681 91.4803H19.9844C19.9963 91.641 20.0455 91.7746 20.132 91.8812C20.2185 91.9879 20.331 92.0674 20.4697 92.12C20.6098 92.1726 20.7664 92.1988 20.9394 92.1988C21.1198 92.1988 21.2778 92.1718 21.4135 92.1177C21.5507 92.0622 21.658 91.9856 21.7355 91.888C21.8131 91.7889 21.8526 91.6733 21.8541 91.5411C21.8526 91.421 21.8175 91.3219 21.749 91.2438C21.6804 91.1642 21.5842 91.0982 21.4605 91.0456C21.3382 90.9915 21.1951 90.9435 21.031 90.9014L20.51 90.7663C20.1327 90.6687 19.8345 90.5208 19.6154 90.3226C19.3977 90.1229 19.2888 89.8578 19.2888 89.5275C19.2888 89.2557 19.3619 89.0177 19.508 88.8134C19.6556 88.6092 19.8562 88.4508 20.1096 88.3382C20.3631 88.2241 20.6501 88.167 20.9707 88.167C21.2957 88.167 21.5805 88.2241 21.825 88.3382C22.071 88.4508 22.2641 88.6077 22.4042 88.8089C22.5444 89.0086 22.6167 89.2384 22.6212 89.4982H21.8228Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6043_124548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.214 8.72168H8.9362C6.7623 8.72168 5 10.4966 5 12.686V32.5074C5 34.6968 6.7623 36.4717 8.9362 36.4717H115.214C117.387 36.4717 119.15 34.6968 119.15 32.5074V12.686C119.15 10.4966 117.387 8.72168 115.214 8.72168Z",
    fill: "white"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6171 15.0645H45.1488C43.8445 15.0645 42.7871 16.1294 42.7871 17.443C42.7871 18.7567 43.8445 19.8216 45.1488 19.8216H65.6171C66.9214 19.8216 67.9788 18.7567 67.9788 17.443C67.9788 16.1294 66.9214 15.0645 65.6171 15.0645Z",
    fill: "#E0E0E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7874 25.3721H45.1488C43.8445 25.3721 42.7871 26.437 42.7871 27.7506C42.7871 29.0643 43.8445 30.1292 45.1488 30.1292H79.7874C81.0917 30.1292 82.1491 29.0643 82.1491 27.7506C82.1491 26.437 81.0917 25.3721 79.7874 25.3721Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.012 30.1287C33.1424 30.1287 36.4908 26.7565 36.4908 22.5966C36.4908 18.4367 33.1424 15.0645 29.012 15.0645C24.8816 15.0645 21.5332 18.4367 21.5332 22.5966C21.5332 26.7565 24.8816 30.1287 29.012 30.1287Z",
    fill: "#FDBE44"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.411 24.737H24.5254L26.1379 20.124H27.1622L28.7769 24.737H27.8913L26.6679 21.07H26.6321L25.411 24.737ZM25.4401 22.9283H27.8555V23.5995H25.4401V22.9283Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9684 24.737H29.0828L30.6953 20.124H31.7196L33.3343 24.737H32.4486L31.2253 21.07H31.1895L29.9684 24.737ZM29.9975 22.9283H32.4129V23.5995H29.9975V22.9283Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6043_124548",
    x: 36.8496,
    y: 40.8145,
    width: 124.15,
    height: 37.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6043_124548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6043_124548",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6043_124548",
    x: 0,
    y: 74.9072,
    width: 124.15,
    height: 37.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6043_124548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6043_124548",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6043_124548",
    x: 0,
    y: 6.72168,
    width: 124.15,
    height: 37.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6043_124548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6043_124548",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconGetStartedTermPolicy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-get-started-term-policy.90d386a529fd1b4fff3569a5511b51a5.svg";